module.exports = __webpack_public_path__ + "static/media/everyday_digital_and_weekend_papers_cropped.d4125b76.png";